<template>
  <div class="field-comparison-label grey--text text--darken-2">
    <v-icon :color="color" size="18" class="mr-1">{{ icon }}</v-icon>
    <span class="field">{{ field }}</span>
  </div>
</template>

<script>
import { PublicationFieldDiffType } from '@/enums';

const DIFF_TYPE_TO_PROPS = {
  [PublicationFieldDiffType.ADD]: {
    color: 'primary',
    icon: 'add_circle',
  },
  [PublicationFieldDiffType.MATCH]: {
    color: 'success',
    icon: 'check_circle',
  },
  [PublicationFieldDiffType.MISSING]: {
    color: 'error',
    icon: 'remove_circle',
  },
  [PublicationFieldDiffType.MISMATCH]: {
    color: 'error',
    icon: 'cancel',
  },
};

export default {
  name: 'FieldComparisonLabel',
  props: {
    field: {
      type: String,
      required: true,
    },
    diffType: {
      type: String,
      required: true,
      validator: (val) =>
        Object.values(PublicationFieldDiffType).includes(val),
    },
  },
  computed: {
    icon() {
      return DIFF_TYPE_TO_PROPS[this.diffType].icon;
    },
    color() {
      return DIFF_TYPE_TO_PROPS[this.diffType].color;
    },
  },
};
</script>

<style lang="scss" scoped>
.field-comparison-label {
  padding-top: 12px;
  > .field {
    font-size: 12px;
    line-height: 12px;
    font-weight: bold;
  }
}
</style>
